export default "__VITE_ASSET__wxQhArLk__"